import { loadStripe } from '@stripe/stripe-js';

// Publishable key comes from the environment so dev can use a Stripe TEST key
// while production keeps the live key. Set VUE_APP_STRIPE_PK in frontend/.env.
const PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PK
  || 'pk_live_51Q8edGDyUrGV7HGQrEO2mSISdCaPAejCjAmduziAxXiRTb26PZEhCsraG5zetFH7PSMFrOZBoyXjpC69wySLUS9500KSfzHVSy';

export const stripePromise = loadStripe(PUBLISHABLE_KEY);
stripePromise.catch(() => {});   // a page that never pays must not crash when Stripe can't load

// Stripe in the shopper's site language: the card form's hints and every decline message
// ("Your card was declined", "insufficient funds") read in Chinese on /zh.
const _byLocale = {};
export function stripeFor(lang) {
  let l = lang;
  if (!l) { try { l = localStorage.getItem('chds_lang') || 'en'; } catch (e) { l = 'en'; } }
  const locale = String(l).startsWith('zh') ? 'zh' : 'en';
  if (!_byLocale[locale]) {
    // a failed download (weak mobile data) is NOT cached: the next call tries again
    _byLocale[locale] = loadStripe(PUBLISHABLE_KEY, { locale }).then((st) => {
      if (!st) throw new Error('Stripe unavailable');
      return st;
    }).catch((e) => { delete _byLocale[locale]; throw e; });
  }
  return _byLocale[locale];
}
